import { confirmTrade, getRecounting, getFileDownloadUrl } from '@/api/counting';

const tradeOperateMixins = {
  data() {
    return {
      isOperateShow: false,
      textConfig: {},
      opLoading: false,
      currentRow: {},
    };
  },
  methods: {
    handleOperate(operation, row) {
      const list = {
        1: {
          title: '提示',
          messageTip: '是否确定要重新获取双方源数据？',
          isPass: true,
          operation: 1,
        },
        2: {
          title: '提示',
          messageTip: '是否确定已完成当日对账？',
          isPass: true,
          operation: 2,
        },
      };
      this.countingNo = row.countingNo;
      this.currentRow = { ...row };
      this.textConfig = list[operation] || '-';
      this.isOperateShow = true;
    },
    // 确认操作
    async handleOperateSubmit(params) {
      try {
        const { operation } = this.textConfig;
        this.opLoading = true;
        // 确认对账
        if (operation === 2) {
          await confirmTrade({
            countingNo: this.countingNo,
            type: 1,
            ...params,
          });
        }
        // 重新获取
        if (operation === 1) {
          await getRecounting({
            countingNo: this.countingNo,
          });
        }
        this.$message.success('操作成功!');
        this.isOperateShow = false;
        this.opLoading = false;
        this.getList();
      } catch (error) {
        console.log(error);
        this.opLoading = false;
      }
    },
    // 下载
    handleDownloadFile(params) {
      getFileDownloadUrl(params).then((res) => {
        const { filesUrl } = res.data || {};
        if (filesUrl.length) {
          const triggerDelay = 100;
          const removeDelay = 1000;
          filesUrl.forEach((item, index) => {
            this.createElementLink(item, index, index * triggerDelay, removeDelay);
          });
        }
      }).catch(() => { });
    },
    createElementLink(url, index, triggerDelay, removeDelay) {
      setTimeout(() => {
        // 动态添加iframe,设置src,然后删除
        const frame = document.createElement('iframe'); // 创建a对象
        frame.setAttribute('style', 'display: none');
        frame.setAttribute('src', url);
        frame.setAttribute('id', index);
        document.body.appendChild(frame);
        setTimeout(() => {
          const node = document.getElementById(index);
          node.parentNode.removeChild(node);
        }, removeDelay);
      }, triggerDelay);
    },
  },
};
export default tradeOperateMixins;
